var _Circle, _Path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Circle, Path } from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: style */
function SvgPending(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-5 -5 10 10",
    width: "1em",
    height: "1em"
  }, props), _Circle || (_Circle = /*#__PURE__*/React.createElement(Circle, {
    className: "pending_svg__pending",
    r: 4.5
  })), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    className: "pending_svg__pending",
    d: "M0 0v-2.5M0 0l1.732 1"
  })));
}
export default SvgPending;